import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DateListener } from '@zenlayer/util';
import { useCreation } from 'ahooks';
import { useCallback } from 'react';
var initialValue = {
  user: [],
  team: {}
};

var AuthorizationClass = /*#__PURE__*/_createClass(function AuthorizationClass() {
  var _this = this;

  _classCallCheck(this, AuthorizationClass);

  _defineProperty(this, "dateListener", void 0);

  _defineProperty(this, "getAuthorization", function () {
    return _this.dateListener.getValue() || initialValue;
  });

  _defineProperty(this, "setAuthorization", function (auth) {
    _this.dateListener.setValue(auth);
  });

  _defineProperty(this, "useCheckAuth", function (resourceGroupId) {
    var _ref = _this.dateListener.useValueListener() || initialValue,
        _ref$user = _ref.user,
        user = _ref$user === void 0 ? [] : _ref$user,
        _ref$team = _ref.team,
        team = _ref$team === void 0 ? {} : _ref$team;

    var authList = useCreation(function () {
      if (!resourceGroupId) {
        return user;
      }

      var allResourceAuth = team.allResource || [];
      var teamAuth = resourceGroupId === 'ALL_GROUP' ? allResourceAuth : allResourceAuth.concat(team[resourceGroupId] || []);
      return [].concat(_toConsumableArray(user), _toConsumableArray(teamAuth));
    }, [JSON.stringify(user), JSON.stringify(team), resourceGroupId]);
    var check = useCallback(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _args = args.filter(function (k) {
        return !!k;
      });

      if (!_args.length) {
        return true;
      }

      return _args.some(function (k) {
        var keys = Array.isArray(k) ? k : [k];
        return keys.every(function (key) {
          return authList.includes(key);
        });
      });
    }, [authList]);
    return [check, authList];
  });

  this.dateListener = new DateListener('console_authorization', {
    setWindow: true
  }, initialValue);
});

var _AuthorizationClass = new AuthorizationClass(),
    setAuthorization = _AuthorizationClass.setAuthorization,
    useCheckAuth = _AuthorizationClass.useCheckAuth; // interface ICheckAuthProps {
//   auth: Parameters<CheckAuthFn>;
//   children?: React.ReactNode;
//   noAuth?: React.ReactNode;
// }
// export default function CheckAuth({ auth, children, noAuth }: ICheckAuthProps) {
//   const [checkAuth] = useCheckAuth();
//   return <>{checkAuth(...auth) ? children : noAuth}</>;
// }


export { setAuthorization, useCheckAuth };